import type { WritableDraft } from "immer";
import { produce } from "immer";
import type { PropsWithChildren } from "react";
import { useCallback, useState } from "react";
import type { AuthContextState } from "./context-auth";
import { AuthStateContext, defaultAuthContextState } from "./context-auth";

export type AuthStateProviderProps = {
  initial?: AuthContextState;
};

export function AuthStateProvider(
  props: PropsWithChildren<AuthStateProviderProps>,
) {
  const [state, setState] = useState(props.initial ?? defaultAuthContextState);
  const update = useCallback(
    (callback: (draft: WritableDraft<AuthContextState>) => void) => {
      setState((prev) =>
        produce(prev, (d) => {
          callback(d);
        }),
      );
    },
    [],
  );

  return (
    <AuthStateContext.Provider
      value={{
        ...state,
        update,
      }}
    >
      {props.children}
    </AuthStateContext.Provider>
  );
}
